import { ISiteSettings } from '@topshots/core-models';
import { useFormikContext } from 'formik';
import { CardContent } from 'shared-components';
import { FormLayout } from 'shared-components';
import { FormGroup } from 'shared-components';
import { Label } from 'shared-components';
import { Input } from 'shared-components';

export const SettingsStripe = () => {
  const { getFieldProps } = useFormikContext<ISiteSettings>();
  return (
    <CardContent>
      <FormLayout>
        <FormGroup>
          <Label htmlFor="stripePublishableKey">Stripe publishable key</Label>
          <Input
            {...getFieldProps('stripePublishableKey')}
            type="text"
            id="stripePublishableKey"
          />
        </FormGroup>
        <FormGroup>
          <Label htmlFor="stripeSecretKey">Stripe secret key</Label>
          <Input
            {...getFieldProps('stripeSecretKey')}
            type="text"
            id="stripeSecretKey"
          />
        </FormGroup>
      </FormLayout>
    </CardContent>
  );
};
